import { render, staticRenderFns } from "./StaticDepartment.vue?vue&type=template&id=221af9e7&lang=html"
import script from "./StaticDepartment.vue?vue&type=script&lang=js"
export * from "./StaticDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports